import React, { Component } from "react";
import locales_es from "../../locales/es";
import DateTimeService from "../../modules/DateTimeService";
import "./styles.css";
import {
  EMAIL_REMINDER_STATUS_OPENED,
  EMAIL_REMINDER_STATUS_SENT,
} from "../../models/constants";

export default class Schedules extends Component {
  constructor() {
    super();
    this.dateTimeService = new DateTimeService();
  }
  
  formatDateTime(datetime) {
    return datetime
      ? this.dateTimeService.parseEventDate(datetime, false, "full-string") +
      " " +
      this.dateTimeService.parseEventTime(datetime, "full-string")
      : locales_es.no;
  }
  
  renderSchedulesReminders(schedules, channel = "email") {
    const result = [];
    if (schedules.length) {
      schedules.forEach((sch, index) => {
        console.log(sch);
        let iconClassName = "pointer ";
        let status = "";
        let showPopover = false;
        let popoverHtml = "";
        let title = locales_es.scheduleNotifications[sch.notification_type] || sch.notification_type;
        
        if (channel === "email") {
          iconClassName += "flaticon2-check-mark ";
          const emailStatuses = {
            pending: "btn-font-metal",
            sent: "btn-font-metal",
            opened: "btn-font-info",
            fail: "btn-font-danger",
            failed: "btn-font-danger",
          };
          iconClassName += emailStatuses[sch.email_status] || "btn-font-metal";
          status = sch.email_status;
          showPopover = true;
          
          popoverHtml = `
            <div>
                <div class="row mb-3">
                    <div class="col-6"><strong>${locales_es.scheduleNotificationsDetailItems.email_scheduled_at}:</strong></div>
                    <div class="col-6 text-right">${this.formatDateTime(sch.email_scheduled_at)}</div>
                </div>
                <div class="row mb-3">
                    <div class="col-6"><strong>✉️ ${locales_es.scheduleNotificationsDetailItems.email_sent_at}:</strong></div>
                    <div class="col-6 text-right">${this.formatDateTime(sch.email_sent_at)}</div>
                </div>
                <div class="row mb-3">
                    <div class="col-6"><strong>${locales_es.scheduleNotificationsDetailItems.email_opened_at}:</strong></div>
                    <div class="col-6 text-right">${this.formatDateTime(sch.email_opened_at)}</div>
                </div>
            </div>
          `;
        } else if (channel === "whatsapp") {
          const hasError = !!sch.whatsapp_error_result;
          iconClassName += ((sch.whatsapp_status === 'fail' || sch.whatsapp_status === 'failed') ? "flaticon2-delete " : "flaticon2-check-mark ");
          iconClassName += hasError ? "btn-font-danger" : "btn-font-info";
          status = sch.whatsapp_status;
          showPopover = true;
          
          popoverHtml = `
            <div>
                <div class="row mb-3">
                    <div class="col-6"><strong>Estado:</strong></div>
                    <div class="col-6 text-right">${status || locales_es.no}</div>
                </div>
                <div class="row mb-3">
                    <div class="col-6"><strong>${locales_es.scheduleNotificationsDetailItems.email_scheduled_at}:</strong></div>
                    <div class="col-6 text-right">${this.formatDateTime(sch.email_scheduled_at)}</div>
                </div>
                <div class="row mb-3">
                    <div class="col-6"><strong>📩 Enviado:</strong></div>
                    <div class="col-6 text-right">${this.formatDateTime(sch.whatsapp_sent_at)}</div>
                </div>
                ${
            hasError
              ? `<div class="row mb-3">
                          <div class="col-12 text-danger ellipsis"><strong>Error:</strong> ${sch.whatsapp_error_result}</div>
                      </div>`
              : ""
          }
            </div>
          `;
        }
        
        result.push(
          <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
            {title}
            {showPopover ? (
              <a
                type="button"
                data-toggle="popover"
                data-trigger="hover"
                data-placement="top"
                data-content={popoverHtml}
                data-html="true"
                data-original-title={locales_es.scheduleNotificationsDetailTitle}
              >
                <span className="badge">
                  <i className={iconClassName} />
                  {channel === "email" &&
                    (status === EMAIL_REMINDER_STATUS_SENT ||
                      status === EMAIL_REMINDER_STATUS_OPENED) && (
                      <i className={iconClassName} />
                    )}
                </span>
              </a>
            ) : (
              <span className="badge">
                <i className={iconClassName} />
              </span>
            )}
          </li>
        );
      });
    }
    return result;
  }
  
  render() {
    const { data } = this.props;
    return (
      <div className="mt-3 mb-5">
        <strong className="col-form-label d-inline-block mb-1">Notificaciones automáticas</strong>
        <div className="row">
          <ul className="list-group col mb-3 mb-md-0">
            <li className="list-group-item font-weight-bold text-primary">
              <i className="fas fa-envelope mr-2" />
              Email
            </li>
            {this.renderSchedulesReminders(data, "email")}
          </ul>
          <ul className="list-group col">
            <li className="list-group-item font-weight-bold text-success">
              <i className="socicon-whatsapp mr-2" />
              WhatsApp
            </li>
            {this.renderSchedulesReminders(data, "whatsapp")}
          </ul>
        </div>
        {window.initPopovers({ disableAutoHide: true })}
      </div>
    );
  }
}
